import { ref } from '@vue/composition-api'
import { apiToastSuccess, apiToastWarning } from '@/@core/utils/toast'
import { getDateFromTimestamp, getFromattedTimeFromDate } from '@/common-utils'
import { download, getDownloadTypeName } from '@/@core/utils/utils'
import store from '@/store'
import { GET_DOWNLOADS_LIST } from '@/store/modules/common.module'
import { DOWNLOAD_FILE_STATUS } from '@/constants'
import { RESET_DOWNLOADS_NAV_INDICATOR } from '@/store/modules/notification.module'

export function useDownloads() {
  const downloads = ref([])
  const isLoaded = ref(false)
  const currentPage = ref(1)
  const perPage = ref(10)
  const totalDownloads = ref(0)
  const hasPagination = ref(true)

  const tableColumns = [
    { key: 'respectiveName', label: 'Name' },
    { key: 'downloadType', label: 'Type' },
    { key: 'createdAt', label: 'Date' },
    { key: 'fileType', label: 'File Type' },
    { key: 'status', label: 'Status' },
    { key: 'downloadUrl', label: 'Download Link' },
  ]

  async function getDownloadsList() {
    try {
      const params = {
        page: currentPage.value - 1,
        limit: perPage.value,
      }
      const result = await store.dispatch(GET_DOWNLOADS_LIST, params)
      downloads.value = result.data.data.downloads
      totalDownloads.value = result.data.data.count
    } catch {
      // error toast handled by axios interceptor
    } finally {
      isLoaded.value = true
    }
  }

  function initDownloads() {
    store.commit(RESET_DOWNLOADS_NAV_INDICATOR)
    getDownloadsList()
  }

  function onPageChange(page) {
    currentPage.value = page
    getDownloadsList()
  }

  function getDownloadStatus(status) {
    return Object.values(DOWNLOAD_FILE_STATUS).find(_ => _.VALUE === status)?.LABEL
  }

  // The reason a failed download shows under its status, or an empty string.
  function getErrorReason(item) {
    if (item?.status !== DOWNLOAD_FILE_STATUS.ERROR.VALUE) return ''
    return item.errorReason || ''
  }

  function copyDownloadLink(link) {
    navigator.clipboard
      .writeText(link)
      .then(() => {
        apiToastSuccess('Download Link Copied')
      })
      .catch(err => {
        apiToastWarning(err)
      })
  }

  return {
    downloads,
    isLoaded,
    currentPage,
    perPage,
    totalDownloads,
    hasPagination,
    tableColumns,
    getDownloadsList,
    initDownloads,
    onPageChange,
    getDownloadStatus,
    getErrorReason,
    copyDownloadLink,
    getDateFromTimestamp,
    getFromattedTimeFromDate,
    download,
    getDownloadTypeName,
    DOWNLOAD_FILE_STATUS,
  }
}
